import React from 'react';
import { translate } from 'react-i18next';

import { Form } from 'common/components';

const NotificationConfigFormDepreciation = ({
  depreciations,
  errors,
  handleValueChange,
  isSubmitted,
  t,
  values,
}) => {
  return (
    <Form.Section title={t('notification_config.form.depreciations')}>
      <div className="row align-items-center">
        <div className="col-12">
          <Form.FieldSelect
            error={(isSubmitted && errors.financialDepreciation) || {}}
            name={'financialDepreciation'}
            label={t('notification_config.fields.financialDepreciation')}
            handleChange={handleValueChange}
            t={t}
            value={values.financialDepreciation}
          >
            {depreciations.map((depreciation) => (
              <option key={depreciation.id} value={depreciation.id}>
                {depreciation.key} - {depreciation.name}
              </option>
            ))}
          </Form.FieldSelect>
        </div>
        <div className="col-12">
          <Form.FieldSelect
            error={(isSubmitted && errors.fiscalDepreciation) || {}}
            name={'fiscalDepreciation'}
            label={t('notification_config.fields.fiscalDepreciation')}
            handleChange={handleValueChange}
            t={t}
            value={values.fiscalDepreciation}
          >
            {depreciations.map((depreciation) => (
              <option key={depreciation.id} value={depreciation.id}>
                {depreciation.key} - {depreciation.name}
              </option>
            ))}
          </Form.FieldSelect>
        </div>
      </div>
    </Form.Section>
  );
};

export default translate()(NotificationConfigFormDepreciation);



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_config/components/form/sections/NotificationConfigFormDepreciations.js